exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/shared/components/tables/sortable-table/sortable-cell/sortable-cell.component.css
// module id = ../../../../../src/app/shared/components/tables/sortable-table/sortable-cell/sortable-cell.component.css
// module chunks = main